import RoundedButton from 'components/RoundedButton';
import React from 'react';
import HostImageCards from 'reusable-components/forms/ContactHostForm/HostImageCards';
import { useSendOfferRequestToHosts } from 'reusable-components/forms/ContactHostForm/RequestPersonalizedOfferForm/hooks/useSendOfferRequestToHosts';
import BadgeWithCheckmark from 'reusable-components/icons/fullcolor/BadgeWithCheckmark';
import { useTrekker } from 'utils/analytics';
import { CONTACT_HOST_SOURCES } from '~/constants';
import useLocalizedNavigate from '~/hooks/useLocalizedNavigate';

const CSS = require('./OtherLocalsSuccessSection.module.scss');

interface OtherLocalsSuccessSectionProps {
  availableHosts: string[];
  source: CONTACT_HOST_SOURCES;
  images: string[];
}

function OtherLocalsSuccessSection({
  availableHosts,
  source,
  images,
}: OtherLocalsSuccessSectionProps) {
  const navigate = useLocalizedNavigate();
  const trekker = useTrekker();

  const { triggerSendOfferRequest, status } = useSendOfferRequestToHosts({
    source,
  });

  const onSendOfferRequest = async (event) => {
    trekker.event('click', {
      component: ['SendRequestToOtherHostsButton'],
      buttonText: event?.target?.textContent,
    });
    triggerSendOfferRequest({ hostIds: availableHosts });
  };

  const goToChatOverview = () => {
    navigate('/messages/', { replace: true });
  };

  return (
    <section className={CSS.OtherLocalsSuccessSection}>
      <div className={CSS.OtherLocalsContainer} data-variant={status}>
        <div className={CSS.ImagesContainer}>
          <HostImageCards images={images} />
          {status === 'success' && (
            <BadgeWithCheckmark
              variant="success-inverted"
              className={CSS.BadgeWithCheckmark}
            />
          )}
        </div>
        <h2 className={CSS.Title} data-variant={status}>
          Looking for more options?
        </h2>
        <p className={CSS.Paragraph}>
          Increase your chances by sending your request to other available
          locals.
        </p>
        {status !== 'success' && (
          <RoundedButton
            onClick={onSendOfferRequest}
            edgeRounding="medium"
            elevated
            size="S"
            isLoading={status === 'loading'}
          >
            Send request to other locals
          </RoundedButton>
        )}
        {status === 'success' && (
          <RoundedButton
            onClick={goToChatOverview}
            edgeRounding="medium"
            elevated
            size="S"
            pink
          >
            Go to chat overview
          </RoundedButton>
        )}
      </div>
    </section>
  );
}

export default OtherLocalsSuccessSection;
